import React, { FC, forwardRef } from 'react'

import { FormElementProps } from '@Components/FormElements/FormElementProps'
import { BaseFormInput } from '@Components/FormElements/UI/BaseFormInput'
import { useFormElementState } from '@Components/FormElements/useFormElementState'

export type TextFieldProps = FormElementProps & Omit<React.JSX.IntrinsicElements['input'], 'size'> & { labelActive?: boolean }

export const TextField: FC<TextFieldProps> = forwardRef(
  (
    {
      adornments,
      error,
      id,
      label,
      labelActive = false,
      name,
      size,
      variant,
      withoutLabelAnimation,
      wrapperClassName,
      ...props
    }: TextFieldProps,
    ref,
  ) => {
    const { formActive, ...state } = useFormElementState<'input'>({ ...props })

    return (
      <BaseFormInput
        adornments={adornments}
        error={error}
        formActive={formActive || labelActive}
        id={id}
        label={label}
        size={size}
        variant={variant}
        withoutLabelAnimation={withoutLabelAnimation}
        wrapperClassName={wrapperClassName}
        {...props}
      >
        <input
          id={id}
          name={name}
          placeholder={!withoutLabelAnimation ? undefined : label}
          ref={ref}
          {...props}
          {...state}
        />
      </BaseFormInput>
    )
  },
)
